import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/App.css";
import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import AdminLayout from "./layouts/admin";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./RootReducer";
import theme from "./theme/theme";
import { overviewSaga } from "./redux/changeLog/saga";
import { partnersSaga } from "./redux/partners/saga";
import { authenticationSaga } from "./redux/auth/saga";
import { subCompaniesSaga } from "views/admin/partnerDetail/services/subCompanies/saga";
import "./polyfills";
import GlobalLoading from "components/loading/GlobalLoading";

const sagaMiddleware = createSagaMiddleware();

//@ts-ignore
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(overviewSaga);
sagaMiddleware.run(authenticationSaga);
sagaMiddleware.run(partnersSaga);
sagaMiddleware.run(subCompaniesSaga);

ReactDOM.render(
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <BrowserRouter>
          <GlobalLoading />
          <Switch>
            {/*<Route path={`/login`} component={AuthLayout} />*/}
            <Route path={`/`} component={AdminLayout} />
            <Redirect from="/" to="/overview" />
          </Switch>
        </BrowserRouter>
      </React.StrictMode>
    </ChakraProvider>
  </Provider>,
  document.getElementById("root")
);
